import { call, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";
import * as actionTypes from "../ActionTypes";

import {
  saveResourceVideoSuccess,
  saveResourceVideoFailure,
  updateResourceVideoSuccess,
  updateResourceVideoFailure,
  deleteResourceVideoSuccess,
  deleteResourceVideoFailure,
  readResourceVideoSuccess,
  readResourceVideoFailure,
} from "./ResourceVideosActions";

import {
  saveResourceVideo,
  updateResourceVideo,
  deleteResourceVideo,
  readResourceVideos,
} from "./resourceVideosAPI";

/* SAVE */
function* saveResourceVideoSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const res = yield call(saveResourceVideo, apiPayloadRequest);

    if (res?.type === 1) {
      yield put(saveResourceVideoSuccess(res.data));
      toast.success(res.message || "Resource Video Saved!");
      action.callback?.({ type: 1, data: res.data });
    } else throw new Error(res.error);
  } catch (error) {
    yield put(saveResourceVideoFailure(error.message));
    toast.error(error.message);
    action.callback?.({ type: 0, error: error.message });
  }
}

/* UPDATE */
function* updateResourceVideoSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const res = yield call(updateResourceVideo, apiPayloadRequest);

    if (res?.type === 1) {
      yield put(updateResourceVideoSuccess(res.data));
      toast.success(res.message || "Resource Video Updated!");
      action.callback?.({ type: 1, data: res.data });
    } else throw new Error(res.error);
  } catch (error) {
    yield put(updateResourceVideoFailure(error.message));
    toast.error(error.message);
    action.callback?.({ type: 0, error: error.message });
  }
}

/* DELETE */
function* deleteResourceVideoSaga(action) {
  try {
    const res = yield call(deleteResourceVideo, action.payload);

    if (res?.type === 1) {
      yield put(deleteResourceVideoSuccess(action.payload));
      toast.success(res.message || "Resource Video Deleted!");
      action.callback?.({ type: 1, data: action.payload });
    } else throw new Error(res.error);
  } catch (error) {
    yield put(deleteResourceVideoFailure(error.message));
    toast.error(error.message);
    action.callback?.({ type: 0, error: error.message });
  }
}

/* READ */
function* readResourceVideosSaga(action) {
  try {
    const res = yield call(readResourceVideos, action.payload);

    if (res?.type === 1) {
      yield put(readResourceVideoSuccess(res.data));
      action.callback?.({ type: 1, data: res.data });
    } else throw new Error(res.error);
  } catch (error) {
    yield put(readResourceVideoFailure(error.message));
    action.callback?.({ type: 0, error: error.message });
  }
}

/* WATCHER */
export default function* resourceVideosWatcherSaga() {
  yield takeLatest(actionTypes.SAVE_RESOURCE_VIDEO_REQUEST, saveResourceVideoSaga);
  yield takeLatest(actionTypes.UPDATE_RESOURCE_VIDEO_REQUEST, updateResourceVideoSaga);
  yield takeLatest(actionTypes.DELETE_RESOURCE_VIDEO_REQUEST, deleteResourceVideoSaga);
  yield takeLatest(actionTypes.READ_RESOURCE_VIDEO_REQUEST, readResourceVideosSaga);
}
